import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSkip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSkip"><Path fillRule="evenodd" clipRule="evenodd" d="M20 3.99988V19.9999H18V3.99988H20Z" fill="currentColor"/><Path d="M4 3.65723V20.3426L16.8349 11.9999L4 3.65723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSkip;
